export const IDENTITY_MISMATCH_RELOAD_THROTTLE_MS = 60000;
const reloadAttemptKey = (cookieBusinessId)=>"identityMismatchReloadAt-".concat(cookieBusinessId);
export function hasRestoredIdentityMismatch(cookieClaims, storeClaims) {
    var _cookieClaims_viewAsClientEmail, _storeClaims_viewAsClientEmail;
    return cookieClaims.businessId !== storeClaims.businessId || cookieClaims.email !== storeClaims.email || ((_cookieClaims_viewAsClientEmail = cookieClaims.viewAsClientEmail) !== null && _cookieClaims_viewAsClientEmail !== void 0 ? _cookieClaims_viewAsClientEmail : null) !== ((_storeClaims_viewAsClientEmail = storeClaims.viewAsClientEmail) !== null && _storeClaims_viewAsClientEmail !== void 0 ? _storeClaims_viewAsClientEmail : null);
}
export function isReloadAttemptThrottled(storage, nowMs, cookieBusinessId) {
    const lastAttemptMs = Number(storage.getItem(reloadAttemptKey(cookieBusinessId)));
    return lastAttemptMs > 0 && nowMs - lastAttemptMs < IDENTITY_MISMATCH_RELOAD_THROTTLE_MS;
}
export function markReloadAttempt(storage, nowMs, cookieBusinessId) {
    storage.setItem(reloadAttemptKey(cookieBusinessId), String(nowMs));
}
export function buildIdentityMismatchReloadLog(param) {
    let { trigger, cookieClaims, storeClaims, pathname } = param;
    var _cookieClaims_viewAsClientEmail, _storeClaims_viewAsClientEmail;
    return {
        type: 'identityMismatchReload',
        trigger,
        cookieBusinessId: cookieClaims.businessId || null,
        storeBusinessId: storeClaims.businessId || null,
        emailMismatch: cookieClaims.email !== storeClaims.email,
        viewModeMismatch: ((_cookieClaims_viewAsClientEmail = cookieClaims.viewAsClientEmail) !== null && _cookieClaims_viewAsClientEmail !== void 0 ? _cookieClaims_viewAsClientEmail : null) !== ((_storeClaims_viewAsClientEmail = storeClaims.viewAsClientEmail) !== null && _storeClaims_viewAsClientEmail !== void 0 ? _storeClaims_viewAsClientEmail : null),
        pathname
    };
}
